/* eslint-disable */
// @ts-nocheck
export function initHeroSampleIdle() {
  var root = document.getElementById('hero-sample-root')
  if (!root) return

  function bindTreeToggle(scope) {
    scope.querySelectorAll('.mi-row--toggle').forEach(function (row) {
      if (row.dataset.boundToggle) return
      row.dataset.boundToggle = '1'
      row.addEventListener('click', function () {
        var group = row.closest('.mi-bom__group')
        if (!group) return
        group.setAttribute(
          'data-open',
          group.getAttribute('data-open') === 'true' ? 'false' : 'true',
        )
      })
    })
  }

  function syncScrollbars(scope) {
    scope.querySelectorAll('.mi-bom--table').forEach(function (t) {
      var rows = t.querySelector('.mi-bom__rows')
      if (!rows) return
      function sync() {
        t.style.setProperty('--mi-sb', '0px')
      }
      sync()
      window.addEventListener('resize', sync)
      if (window.ResizeObserver) new ResizeObserver(sync).observe(rows)
    })
  }

  bindTreeToggle(root)
  syncScrollbars(root)
  root.setAttribute('data-active-sample', 'idle')
}
